import { Editor } from '@tiptap/core';
import React from 'react';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';
import { cn } from '@/utils';

interface OrderedListMenuItemProps {
	editor: Editor | null;
}

const OrderedListMenuItem = (props: OrderedListMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<Button
			onClick={() => editor.chain().focus().toggleOrderedList().run()}
			className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:size-6 [&>svg]:reset p-0 [&>svg]:left-[0px]', {
				'text-brand-blue': editor.isActive('orderedList'),
			})}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<Icon name="orderedList" size={24} />
		</Button>
	);
};

export { OrderedListMenuItem };
